<template>
  <div>
    <BaseTitle :title="$t(!editable ? 'content.school_view' : edit ? 'content.school_edit' : 'content.school_create')" />
    <v-row>
      <v-col cols="12" md="auto" style="width: 330px">
        <v-card>
          <div class="pa-8 mb-4">
            <div v-if="showPhoto">
              <div class="app-section-title">{{ $t('content.school_upload_title') }}</div>
              <form-group :name="$t('form.logo')" :validator="$v.form.logo" no-gutter>
                <template slot-scope="{ attrs }">
                  <image-box
                    v-model="form.logo"
                    v-bind="attrs"
                    :with-upload="editable"
                    :upload-btn-text="$t(edit ? 'change_photo' : 'upload')"
                    :image-preview="logoUrl"
                    @change="$v.form.logo.$touch()"
                    class="mt-4"
                  />
                </template>
              </form-group>
            </div>
            <v-btn color="primary" block class="btn-primary-custom" v-if="!showPhoto" @click="togglePhoto">
              {{ $t('content.add_photo') }}
            </v-btn>
          </div>
        </v-card>
        <v-card>
          <div class="px-8 py-4">
            <form-group :name="$t('form.status_billing')" :validator="$v.form.billingStatus">
              <template slot-scope="{ attrs }">
                <v-select
                  :items="status"
                  :label="$t('form.status_billing')"
                  :disabled="!editable"
                  v-bind="attrs"
                  v-model="form.billingStatus"
                  width="100"
                >
                  <template #item="{item}">{{ $t(item.text) }}</template>
                  <template #selection="{item}">{{ $t(item.text) }}</template>
                </v-select>
              </template>
            </form-group>
            <!-- <div class="app-section-title">{{ $t('contract_period') }}</div> -->
            <!-- <form-group :name="$t('from_date')" :validator="$v.form.billingPeriodeFrom">
              <template slot-scope="{ attrs }">
                <v-menu
                  ref="menuFrom"
                  v-model="menuFrom"
                  :close-on-content-click="false"
                  :return-value.sync="menuFrom"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template #activator="{ on, attrs:attrActivator }">
                    <v-text-field
                      v-model="form.billingPeriodeFrom"
                      :label="$t('from_date')"
                      disabled
                      readonly
                      v-bind="{ ...attrActivator, ...attrs }"
                      v-on="on"
                    >
                      <template #append>
                        <svg-icon icon="calendar" class="primary--text mr-3" />
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="form.billingPeriodeFrom" :max="form.billingPeriodeTo" :locale="$i18n.locale">
                    <v-spacer />
                    <v-btn text color="primary" @click="menuFrom = false">{{ $t('cancel') }}</v-btn>
                    <v-btn text color="primary" @click="$refs.menuFrom.save(form.billingPeriodeFrom)">{{ $t('ok') }}</v-btn>
                  </v-date-picker>
                </v-menu>
              </template>
            </form-group>
            <form-group :name="$t('to_date')" :validator="$v.form.billingPeriodeTo" class="mb-0">
              <template slot-scope="{ attrs }">
                <v-menu
                  ref="menuTo"
                  v-model="menuTo"
                  :close-on-content-click="false"
                  :return-value.sync="menuTo"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  width="100"
                >
                  <template v-slot:activator="{ on, attrs: attrActivator }">
                    <v-text-field
                      v-model="form.billingPeriodeTo"
                      :label="$t('to_date')"
                      disabled
                      readonly
                      v-bind="{ ...attrActivator, ...attrs }"
                      v-on="on"
                    >
                      <template #append>
                        <svg-icon icon="calendar" class="primary--text mr-3" />
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="form.billingPeriodeTo" :min="form.billingPeriodeFrom" :locale="$i18n.locale">
                    <v-spacer />
                    <v-btn text color="primary" @click="menuTo = false">{{ $t('cancel') }}</v-btn>
                    <v-btn text color="primary" @click="$refs.menuTo.save(form.billingPeriodeTo)">{{ $t('ok') }}</v-btn>
                  </v-date-picker>
                </v-menu>
              </template>
            </form-group> -->
          </div>
        </v-card>
      </v-col>
      <v-col>
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-8">
              <div class="app-section-title">{{ $t('information') }}</div>
              <form-group :name="$t('form.province')" :validator="$v.form.provinceId">
                <template slot-scope="{ attrs }">
                  <v-select
                    :items="provinces"
                    :loading="loadingProvinces"
                    :disabled="!editable"
                    item-value="provinceId"
                    item-text="name"
                    v-bind="attrs"
                    v-model="form.provinceId"
                    @change="getCities"
                    @input="$v.form.provinceId.$touch()"
                    @blur="$v.form.provinceId.$touch()"
                  >
                    <template #label>
                      {{ $t('form.province') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-select>
                </template>
              </form-group>
              <form-group :name="$t('form.city')" :validator="$v.form.cityId">
                <template slot-scope="{ attrs }">
                  <v-select
                    :items="cities"
                    :loading="loadingCities"
                    :disabled="!editable"
                    item-value="cityId"
                    item-text="name"
                    v-bind="attrs"
                    v-model="form.cityId"
                    @change="getEducation"
                    @input="$v.form.cityId.$touch()"
                    @blur="$v.form.cityId.$touch()"
                  >
                    <template #label>
                      {{ $t('form.city') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-select>
                </template>
              </form-group>
              <form-group :name="$t('content.education_level')" :validator="$v.form.educationalLevel">
                <template slot-scope="{ attrs }">
                  <v-select
                    :items="educationList"
                    :loading="loadingEducation"
                    :disabled="!editable"
                    item-value="educationalLevel"
                    item-text="educationalLevel"
                    v-bind="attrs"
                    v-model="form.educationalLevel"
                    @change="getSchool"
                    @input="$v.form.educationalLevel.$touch()"
                    @blur="$v.form.educationalLevel.$touch()"
                  >
                    <template #label>
                      {{ $t('content.education_level') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-select>
                </template>
              </form-group>
              <form-group v-if="!this.$route.params.id" :name="$t('form.school_name')" :validator="$v.form.masterSchoolId">
                <template slot-scope="{ attrs }">
                  <v-autocomplete
                    :items="schoolList"
                    :loading="loadingSchool"
                    :disabled="!editable"
                    item-value="masterSchoolId"
                    item-text="schoolName"
                    v-bind="attrs"
                    v-model="form.masterSchoolId"
                    @input="$v.form.masterSchoolId.$touch()"
                    @blur="$v.form.masterSchoolId.$touch()"
                  >
                    <template #label>
                      {{ $t('form.school_name') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-autocomplete>
                </template>
              </form-group>
              <form-group v-else :name="$t('form.school_name')" :validator="$v.form.name">
                <template slot-scope="{ attrs }">
                  <v-text-field v-model="form.name" v-bind="attrs" :disabled="!editable">
                    <template #label>
                      {{ $t('form.school_name') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <div v-if="form.masterSchoolId === null && !this.$route.params.id">
                <form-group :name="$t('content.manual_input_school')" :validator="$v.form.name">
                  <template slot-scope="{ attrs }">
                    <v-text-field
                      v-model="form.name"
                      v-bind="attrs"
                      @input="$v.form.name.$touch()"
                      @blur="$v.form.name.$touch()"
                      :disabled="!editable"
                    >
                      <template #label>
                        {{ $t('content.manual_input_school') }}
                        <span class="error--text">*</span>
                      </template>
                    </v-text-field>
                  </template>
                </form-group>
                <form-group :name="$t('content.npsn')" :validator="$v.form.schoolNumber">
                  <template slot-scope="{ attrs }">
                    <v-text-field
                      v-model="form.schoolNumber"
                      v-bind="attrs"
                      :label="$t('content.npsn')"
                      @input="$v.form.schoolNumber.$touch()"
                      @blur="$v.form.schoolNumber.$touch()"
                      :disabled="!editable"
                    />
                  </template>
                </form-group>
              </div>
              <form-group :name="$t('form.total_user')" :validator="$v.form.totalUser">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    type="number"
                    v-model.number="form.totalUser"
                    v-bind="attrs"
                    v-number
                    min="0"
                    :disabled="!editable"
                    @input="$v.form.totalUser.$touch()"
                    @blur="$v.form.totalUser.$touch()"
                  >
                    <template #label>
                      {{ $t('form.total_user') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <form-group :name="$t('form.telephone')" :validator="$v.form.phoneNumber">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.phoneNumber"
                    v-bind="attrs"
                    v-phone
                    :disabled="!editable"
                    @input="$v.form.phoneNumber.$touch()"
                    @blur="$v.form.phoneNumber.$touch()"
                  >
                    <template #label>
                      {{ $t('form.telephone') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <form-group :name="$t('form.email')" :validator="$v.form.email">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.email"
                    v-bind="attrs"
                    :disabled="!editable"
                    @input="$v.form.email.$touch()"
                    @blur="$v.form.email.$touch()"
                  >
                    <template #label>
                      {{ $t('form.email') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <form-group :name="$t('form.website')" :validator="$v.form.webUrl">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.webUrl"
                    v-bind="attrs"
                    :label="$t('form.website')"
                    :disabled="!editable"
                    @input="$v.form.webUrl.$touch()"
                    @blur="$v.form.webUrl.$touch()"
                  >
                  </v-text-field>
                </template>
              </form-group>
              <div class="app-section-title">{{ $t('address') }}</div>
              <form-group :name="$t('form.school_address')" :validator="$v.form.address">
                <template slot-scope="{ attrs }">
                  <v-textarea
                    v-model="form.address"
                    v-bind="attrs"
                    :disabled="!editable"
                    @input="$v.form.address.$touch()"
                    @blur="$v.form.address.$touch()"
                  >
                    <template #label>
                      {{ $t('form.school_address') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-textarea>
                </template>
              </form-group>
              <form-group :name="$t('form.postal_code')" :validator="$v.form.postalCode">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    minlength="5"
                    maxlength="5"
                    v-model.number="form.postalCode"
                    v-bind="attrs"
                    v-number
                    :label="$t('form.postal_code')"
                    :disabled="!editable"
                    @input="$v.form.postalCode.$touch()"
                    @blur="$v.form.postalCode.$touch()"
                  />
                </template>
              </form-group>
            </div>
          </v-card>
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t(edit ? 'back' : 'cancel') }}</v-btn>
            <v-btn v-if="editable" color="primary" :loading="loading" class="btn-primary-custom" type="submit">
              {{ $t(edit ? 'save' : 'submit') }}
            </v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, email, numeric, maxLength, minValue, minLength } from 'vuelidate/lib/validators';
import phoneNumber from '@/validators/phoneNumber';
import { fileSize, urlOptionalProtocol } from '@/validators';
import onlyWord from '@/validators/onlyWord';
import BaseTitle from '@/components/base/Title';
import ImageBox from '@/components/ImageBox';

export default {
  name: 'SchoolForm',
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BaseTitle,
    ImageBox
  },
  validations: function() {
    return {
      form: {
        logo: { fileSize: fileSize(1) },
        name: !this.form.masterSchoolId || this.edit ? { required, onlyWord, maxLength: maxLength(30) } : {},
        educationalLevel: { required },
        masterSchoolId: this.form.masterSchoolId !== null ? { required } : {},
        schoolNumber: { maxLength: maxLength(100) },
        totalUser: { required, numeric, minValue: minValue(1), maxLength: maxLength(5) },
        phoneNumber: { required, telephone: phoneNumber },
        email: {
          required,
          email,
          [this.validationName](value) {
            if (!value) return true;
            return new Promise(resolve => {
              this.axios
                .get('api/user/validate-email', {
                  params: {
                    email: value,
                    roleId: 2,
                    userId: this.currentUserId || null
                  }
                })
                .then(() => resolve(true))
                .catch(err => {
                  const code = err?.response?.data?.errorMessages;
                  const errorCode = ['isRegistered', 'isRegisteredInactive', 'isRegisteredInAnotherRole'];
                  this.validationName = errorCode?.[code - 1];
                  resolve(false);
                });
            });
          }
        },
        webUrl: { url: urlOptionalProtocol },
        address: { required, maxAddressLength: maxLength(70) },
        provinceId: { required },
        cityId: { required },
        postalCode: { numeric, postalCodeMinLength: minLength(5), maxLength: maxLength(5) },
        billingStatus: { required },
        billingPeriodeFrom: {
          required,
          date: function(value) {
            return this.form.billingPeriodeTo ? value <= this.form.billingPeriodeTo : true;
          }
        },
        billingPeriodeTo: {
          required,
          date: function(value) {
            return this.form.billingPeriodeFrom ? value >= this.form.billingPeriodeFrom : true;
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      provinces: 'Reference/itemProvinces',
      status: 'Reference/itemStatus',
      currentRole: 'Auth/currentRole'
    }),
    cities: {
      get() {
        return this.$store.getters['Reference/itemCities']();
      }
    }
  },
  data: () => ({
    form: {
      logo: null,
      name: '',
      totalUser: 0,
      phoneNumber: '',
      email: '',
      webUrl: '',
      address: '',
      provinceId: null,
      educationalLevel: '',
      masterSchoolId: '',
      schoolNumber: '',
      cityId: '',
      postalCode: '',
      billingStatus: true,
      billingPeriodeFrom: new Date().toISOString().substring(0, 10),
      billingPeriodeTo: '9999-12-31'
    },
    validationName: 'dynamic',
    edit: false,
    loading: false,
    loadingProvinces: false,
    loadingCities: false,
    loadingSchool: false,
    loadingEducation: false,
    hasLoad: false,
    showPhoto: false,
    logoUrl: null,
    menu: false,
    menuFrom: false,
    menuTo: false,
    currentUserId: null,
    schoolList: [],
    educationList: []
  }),
  methods: {
    getData() {
      this.$store.dispatch('School/fetchDetail', this.$route.params.id).then(res => {
        if (res.cityId) {
          this.loadingEducation = true;
          this.$store
            .dispatch('School/getEducation', res.cityId)
            .then(res => (this.educationList = res))
            .finally(() => (this.loadingEducation = false));
        }
        if (res.cityId && res.educationalLevel) {
          this.loadingSchool = true;
          this.$store
            .dispatch('School/getSchool', {
              cityId: res.cityId,
              educationalLevel: res.educationalLevel,
              schoolId: res.schoolId
            })
            .then(res => {
              if (!this.$route.params.id) {
                let obj = {
                  masterSchoolId: null,
                  schoolName: this.$t('content.other')
                };
                // var newData = [...res, obj];
                const newArray = [obj].concat(res);

                this.schoolList = newArray;
              } else {
                this.schoolList = res;
              }
            })
            .finally(() => (this.loadingSchool = false));
        }
        // Object.keys(this.form).forEach(form => (this.form[form] = res[form]));
        Object.keys(this.form).forEach(form => {
          this.form[form] = res[form];
        });
        this.form.logo = null;
        this.currentUserId = res.primarySchoolAdminId;
        if (res.logoUrl) {
          this.logoUrl = res.logoUrl;
          this.showPhoto = true;
        }
        this.getCities();
        this.hasLoad = true;
      });
    },
    getProvinces() {
      this.loadingProvinces = true;
      this.$store.dispatch('Reference/fetchProvinces').finally(() => (this.loadingProvinces = false));
    },
    getCities() {
      if (this.hasLoad) {
        this.form.cityId = null;
        this.form.educationalLevel = null;
        this.form.masterSchoolId = undefined;
        this.form.name = null;
      }
      this.loadingCities = true;
      this.$store.dispatch('Reference/fetchCities', this.form.provinceId).finally(() => {
        this.loadingCities = false;
      });
    },
    getSchool() {
      this.loadingSchool = true;
      this.$store
        .dispatch('School/getSchool', { cityId: this.form.cityId, educationalLevel: this.form.educationalLevel })
        .then(res => {
          if (!this.$route.params.id) {
            let obj = {
              masterSchoolId: null,
              schoolName: this.$t('content.other')
            };
            // var newData = [...res, obj];
            const newArray = [obj].concat(res);
            this.schoolList = newArray;
          } else {
            this.schoolList = res;
          }
        })
        .finally(() => (this.loadingSchool = false));
    },
    getEducation() {
      this.form.educationalLevel = null;
      this.form.masterSchoolId = undefined;
      this.form.name = null;

      this.loadingEducation = true;
      this.$store
        .dispatch('School/getEducation', this.form.cityId)
        .then(res => (this.educationList = res))
        .finally(() => (this.loadingEducation = false));
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loading = true;
      const payload = { ...(this.edit ? { id: this.$route.params.id } : null), ...this.form };
      this.$store
        .dispatch(`School/${this.edit ? 'update' : 'save'}`, payload)
        .then(() => this.$router.push({ name: this.edit ? 'SchoolUpdateSuccess' : 'SchoolSuccess' }))
        .finally(() => (this.loading = false));
    },
    back() {
      this.$router.push({ name: 'SchoolIndex' });
    },
    preventNav(event) {
      if (!this.edit || !this.$v.$anyDirty) return;
      event.preventDefault();
      event.returnValue = '';
    },
    togglePhoto() {
      this.showPhoto = !this.showPhoto;
    }
  },
  created() {
    this.$store.commit('Reference/RESET_CITIES');
    this.getProvinces();

    if (this.$route.params.id) {
      this.edit = true;
      this.getData();
    } else {
      this.hasLoad = true;
    }

    if (!this.editable) {
      this.showPhoto = true;
    }
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav);
    this.$once('hook:beforeDestroy', () => window.removeEventListener('beforeunload', this.preventNav));
  },
  beforeRouteLeave(to, from, next) {
    if (!this.edit && this.$v.$anyDirty && this.$v.$invalid) {
      if (!window.confirm(this.$t('alert.leave_message'))) {
        return;
      }
    }
    next();
  }
};
</script>
